export default {
  en: {
    priceDelta: '+ {price}',
    modifierRequired: 'Choose {title}',
    closed: 'Closed',
  },
  ru: {
    priceDelta: '+ {price}',
    modifierRequired: 'Выберите {title}',
    closed: 'Закрыто',
  },
}
